import { useCart } from "../../../stores/hooks/useCart";
import { useIsLoggedOn } from "../../../stores/hooks/useIsLoggedOn";
import { useNullableDealerAccountInfo } from "../../../stores/hooks/useNullableDealerAccountInfo";

export const useShouldRenderOrderNowButton = (): boolean => {
  const isLoggedOn = useIsLoggedOn();
  const cart = useCart();
  const dealer = useNullableDealerAccountInfo();

  return (
    !!isLoggedOn &&
    Boolean(
      cart?.supportDealerOrder ||
        dealer?.supportConsumerOrder ||
        dealer?.supportDealerOrder,
    )
  );
};
